<template>
  <div
    class="playerList_groupItem"
    :id="`matchList_${data.icon}`"
    :style="{ paddingBottom: `${pbPx}px` }"
  >
    <div class="sportsGroup_label">
      <span class="label_textArea">
        <span class="labelIcon" v-show="isShowLabelIcon">
          <img
            :src="`/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${data.icon}.png`"
          />
        </span>
        <span
          :class="[data.label && data.label.length === 2 ? 'letterSpa' : '']"
          v-text="_valPerFormatHandler(data.label)"
        ></span>
      </span>
      <span class="label_rightArea">
        <span class="rightArea_name" v-text="'运动员：'"></span>
        <span class="rightArea_value" v-text="data.list.length"></span>
      </span>
    </div>
    <div class="players_list">
      <playerItem
        v-for="item in data.list"
        :currCid="currCid"
        :key="item.athleteCode"
        :item="item"
        :mode="mode"
        :detailPathName="detailPathName"
      ></playerItem>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import playerItem from './playerList_itemPanel.vue'
export default {
  name: 'playerList_groupItem',
  mixins: [cup_base_data_mixin],
  components: {
    playerItem,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          label: '艺术体操',
          icon: 'GRY',
          list: [
            {
              playerId: 'WUSG31111',
              playerName: '张靖宇',
              playerLogo: '',
              gender: '1',
              birthDate: '1991.04.23',
              height: '178cm',
              weight: '68kg',
              sportCN: '篮球',
              delegationLogo: '',
              delegationName: '中国',
            },
          ],
        }
      },
    },
    isShowLabelIcon: {
      type: Boolean,
      default: true,
    },
    pbPx: {
      type: Number,
      default: () => {
        return 40
      },
    },
    mode: {
      type: String,
      default: 'mode_other',
    },
    detailPathName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    goDetail(item) {
      if (this.detailPathName) {
        this.pageJump(
          this.$router,
          this.detailPathName,
          {
            delegationId: item.organisationCode,
            sid: item.seasonCode,
          },
          item
        )
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .playerList_groupItem {
    width: 100%;
    height: auto;
    .sportsGroup_label {
      position: relative;
      width: 100%;
      height: 3.472vw;
      background-image: var(--mixtmt_scheduleMatchList_dateBg);
      background-size: 100% auto;
      background-position: left top;
      background-repeat: no-repeat;

      .label_textArea {
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 2;
        transform: translateY(-50%);
        width: 21.55%;
        font-size: 1.38vw;
        color: var(--mixtmt_whiteColor);
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .labelIcon {
          width: 2.778vw;
          height: 2.778vw;
          border: 1.5px solid var(--mixtmt_whiteColor);
          border-radius: 50%;
          overflow: hidden;
          margin-right: 0.694vw;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        & .letterSpa {
          letter-spacing: 0.4vw;
        }
      }
      .label_rightArea {
        position: absolute;
        right: 0;
        top: 0.347vw;
        z-index: 2;
        width: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        color: var(--mixtmt_greyColor3);
        .rightArea_name,
        .rightArea_value {
          font-size: 1.11vw;
        }
        .rightArea_value {
          width: 2.5vw;
          text-align: center;
        }
      }
    }
    .players_list {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
    }
  }
}
</style>
